export const emptyCustomMessage = {
  es: null,
  en: null,
  fr: null,
  de: null,
  it: null,
  pt: null,
  nl: null,
  ko: null,
}

export const customMessageTypeValues = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  success: 'success',
}

export const customMessageTypeLabelKeys = {
  [customMessageTypeValues.info]: 'Información',
  [customMessageTypeValues.warning]: 'Advertencia',
  [customMessageTypeValues.error]: 'Error',
  [customMessageTypeValues.success]: 'Éxito',
}
